import React from "react";
import RfxResponseComp from "newui/features/Rfx/Submission/components/RfxSubmissionStatusPill/RfxResponseComp";
import { TableCell, TableRow } from "components/RFQ/Table";
import tw, { styled } from "twin.macro";
import { Avatar } from "components/RFQ/Avatar";
import { SubmissionDeadline } from "components/RFQ/SubmissionDeadline/SubmissionDeadline";
import RFQStatusComp from "components/RFQ/RFQStatusComp";
import UnreadMessage from "newui/components/UnreadMessage";
import { HStack } from "@chakra-ui/react";
import { RFX_TABS } from "utils/constants";
import { useSupplierRfxNavigator } from "newui/features/Rfx/hooks/useSupplierRfxNavigator";
const RfqList = ({ data, isLoading, isLoadingPagination }) => {
	const navigateToRFx = useSupplierRfxNavigator();
	const SkeletonCustom = styled.div(() => [
		tw`animate-pulse bg-gray-300 w-full h-6`,
	]);

	const SkeleteonRow = () => (
		<TableRow>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
			<TableCell>
				<SkeletonCustom />
			</TableCell>
		</TableRow>
	);
	const tableHeader = [
		{
			name: "Project Name",
			width: "20%",
		},
		{
			name: "Response",
			width: "20%",
		},
		{
			name: "Client",
			width: "20%",
		},
		{
			name: "Submission Deadline",
			width: "20%",
		},
		{
			name: "RFx Status",
			width: "10%",
		},
		{
			action: "",
			width: "10%",
		},
	];

	const navigateToComms = (rfxCardData) => {
		navigateToRFx(rfxCardData, RFX_TABS.COMMS);
	}

	return (
		<div className="overflow-x-auto rounded-md border border-[#EAECF0] bg-white shadow-lg">
			<table className="mb-3 mt-3 w-full table-auto rounded-md border-b border-solid border-[#EAECF0] bg-white">
				<thead style={{ height: "30px" }}>
					<tr className="border-b border-[#EAECF0]">
						{tableHeader.map((th, index) => {
							return (
								<th
									className="font-roboto text-[12px] font-medium text-tertiary-600"
									style={{ width: th.width, textAlign: "left" }}
								>
									<div
										style={{
											marginTop: "-10px",
											marginLeft: index === 0 ? "20px" : "0px",
										}}
									>
										{th?.name}
									</div>
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{!isLoading && (
						<>
							{data.map((rfxCardData, index) => {
								return (
									<tr
										key={index}
										className="border-b border-[#EAECF0] hover:bg-utility-blue-light-50/30"
										onClick={() => navigateToRFx(rfxCardData)}
										style={{ cursor: "pointer" }}
										data-testid={`rfx-row-${rfxCardData?.rfqId ?? rfxCardData?.rfq?.id}`}
									>
										<td className="px-4 py-2">
											<div className="flex items-center">
												<Avatar
													avatar={rfxCardData?.rfq?.project?.logoPath}
													size="lg"
												/>
												<div className="ml-2">
													<h3 className="mt-3 line-clamp-1 overflow-hidden font-roboto text-[14px] font-semibold capitalize text-primary-900">
														{rfxCardData?.rfq?.name}
													</h3>
													<div className="mb-4 font-roboto text-[14px] font-normal uppercase text-primary-500">
														{rfxCardData?.rfq?.supplierList?.name}
													</div>
												</div>
											</div>
										</td>
										<td>
											<RfxResponseComp
												response={rfxCardData?.status}
											></RfxResponseComp>
										</td>
										<td>
											<div className="font-roboto text-[14px] font-medium text-primary-500">
												{rfxCardData?.rfq.client}
											</div>
										</td>
										<td>
											<div>
												<SubmissionDeadline
													className="font-roboto text-[14px] font-medium text-primary-500"
													deadlineDateTime={rfxCardData?.rfq?.submissionDeadline}
													deadlineTimeZone={rfxCardData?.rfq?.submissionTimezone}
													showTimeUnderneath={true}
													submissionStatus={rfxCardData?.status}
												/>
											</div>
										</td>
										<td>
											<HStack>
												<RFQStatusComp
													status={rfxCardData?.rfq?.status}
													isRoundedFull={false}
												></RFQStatusComp>
												<UnreadMessage onClick={(e) => {
													e.stopPropagation();
													navigateToComms(rfxCardData);
												}} value={rfxCardData?.rfq?.unreadMessages} />
											</HStack>
										</td>
										<td></td>
									</tr>
								);
							})}
						</>
					)}
					{isLoadingPagination && (
						<>
							<SkeleteonRow />
							<SkeleteonRow />
							<SkeleteonRow />
						</>
					)}
				</tbody>
			</table>
		</div>
	);
};

export default RfqList;
